import { chunk } from '../immutable'

export const getVerticesAsArrayOf3 = geometry => 
  geometry.vertices.map(({ x, y, z }) => [x, y, z])

export const setVerticesFromBufferOf3 = (geometry, buffer) => 
  geometry.vertices = chunk(buffer, 3).map(([x, y, z]) => ({ x, y, z }))
